export const getCartTotalSegments = (total_segments, keyname) => {
    let name = [];
    let getAllOptions = total_segments.filter(val => val.code === keyname);
    if (getAllOptions.length > 0) {
        name = getAllOptions
    }
    return name;
}